<template>
    <v-container fluid class="pa-0">
        <v-card class="mt-5 pt-3" elevation="3" height="500">
            <v-progress-linear
                :active="$apollo.queries.electricityMeasurementDailys.loading"
                color="primary"
                buffer-value="0"
                indeterminate
                absolute
                top
                height="2"
                class="mx-0 px-0"
            ></v-progress-linear>
            <v-row>
                <v-col
                    cols="0"
                    lg="4"
                    :md="this.propDialog ? '5' : '0'"
                    sm="0"
                    xs="0"
                    class="pb-0 d-lg-flex"
                ></v-col>
                <v-col
                    cols="6"
                    lg="4"
                    :md="this.propDialog ? '3' : '6'"
                    sm="6"
                    class="pb-0"
                >
                    <v-toolbar flat>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="grey darken-2"
                            icon
                            small
                            outlined
                            class="py-1 mr-3"
                            :disabled="yearMonth <= minMonth"
                            @click="addMonths(-1)"
                        >
                            <v-icon>keyboard_arrow_left</v-icon>
                        </v-btn>
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="true"
                            :value.sync="yearMonth"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :value="yearMonthText"
                                    label="Maand"
                                    readonly
                                    v-bind="attrs"
                                    class="text-subtitle-2 shrink"
                                    v-on="on"
                                    hide-details
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="yearMonth"
                                color="primary"
                                type="month"
                                no-title
                                scrollable
                                :min="minMonth"
                                :max="maxMonth"
                            >
                            </v-date-picker>
                        </v-menu>
                        <v-btn
                            color="grey darken-2"
                            icon
                            small
                            outlined
                            class="py-1 ml-3"
                            :disabled="yearMonth >= maxMonth"
                            @click="addMonths(1)"
                        >
                            <v-icon>keyboard_arrow_right</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-col>
                <v-col
                    cols="6"
                    lg="4"
                    :md="this.propDialog ? '4' : '6'"
                    class="pb-0"
                >
                    <div class="text-right mr-5">
                        <span class="caption" style="color: #e91e63">
                            Hoogste piek (levering):
                            <b>{{ highestPeak }}</b> kWh
                        </span>
                        <br />
                        <span class="caption" style="color: #2071b5">
                            Totaal verbruik: <b>{{ totalUsage }}</b> kWh
                        </span>
                        <br />
                        <span class="caption" style="color: #02c281">
                            Totaal Teruglevering:
                            <b>{{ totalTerugLevering }}</b> kWh
                        </span>
                    </div>
                </v-col>
            </v-row>

            <v-row class="px-5">
                <v-col cols="12">
                    <VueApexCharts
                        ref="chart"
                        type="line"
                        height="350"
                        :options="chartOptions"
                        :series="series"
                    >
                    </VueApexCharts>
                </v-col>
                <v-col cols="12">
                    <p
                        class="
                            text-center
                            mt-n9
                            grey--text
                            text--darken-1
                            caption
                            pt-3
                        "
                    >
                        <v-icon class="pb-1 mr-1" small>error_outline</v-icon>
                        <span
                            >DISCLAIMER: NIFE is niet verantwoordelijk voor
                            (door partijen geleverde) data en kan hier niet
                            aansprakelijk voor worden gesteld.</span
                        >
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import VueApexCharts from "vue-apexcharts";
import moment from "moment";

export default {
    name: "elektriciteit-verbruik-maand",
    props: {
        propEan: {
            type: String
        },
        propDialog: {
            type: Boolean,
            default: false
        }
    },
    components: { VueApexCharts },

    apollo: {
        electricityMeasurementDailys: {
            query: gql`
                query electricityMeasurementDailys(
                    $ean: String
                    $datetimeLocalGte: DateTime
                    $datetimeLocalLte: DateTime
                ) {
                    electricityMeasurementDailys(
                        ean: $ean
                        datetimeLocal_Gte: $datetimeLocalGte
                        datetimeLocal_Lte: $datetimeLocalLte
                    ) {
                        edges {
                            node {
                                id
                                datetimeLocal
                                value
                                peakValue
                                isConsumption
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    ean: this.ean,
                    datetimeLocalGte: this.startDate,
                    datetimeLocalLte: this.endDate
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-first", // this setting can avoid query again after fetchMore
            // update: data => data.electricityMeasurementDailys,
            result({ data, loading }) {
                // map result to chart series
                if (!loading && data?.electricityMeasurementDailys) {
                    // initialize leveringSeries
                    var _leveringSeries = {
                        name: "Levering",
                        type: "column",
                        data: Array.from(
                            {
                                length: this.chartOptions.xaxis.categories
                                    .length
                            },
                            () => 0
                        )
                    };

                    // initialize leveringSeries
                    var _terugleveringSeries = {
                        name: "Teruglevering",
                        type: "column",
                        data: Array.from(
                            {
                                length: this.chartOptions.xaxis.categories
                                    .length
                            },
                            () => 0
                        )
                    };

                    // initlialize peakSeries
                    var _peakSeries = {
                        name: "Piek",
                        type: "line",
                        data: Array.from(
                            {
                                length: this.chartOptions.xaxis.categories
                                    .length
                            },
                            () => 0
                        )
                    };

                    // get real data from result
                    let _sortedData = [
                        ...data.electricityMeasurementDailys?.edges
                    ];

                    _sortedData.sort((a, b) =>
                        a.node.datetimeLocal.localeCompare(b.datetimeLocal)
                    );

                    _sortedData.forEach(item => {
                        // use month number as series index
                        const _index =
                            parseInt(item.node.datetimeLocal.substring(8, 10)) -
                            1;

                        // replace series value
                        if (item.node.isConsumption) {
                            _leveringSeries["data"][_index] = item.node.value;
                            _peakSeries["data"][_index] = item.node.peakValue;
                        } else {
                            _terugleveringSeries["data"][_index] =
                                item.node.value;
                        }
                    });

                    this.series = [
                        _leveringSeries,
                        _terugleveringSeries,
                        _peakSeries
                    ];

                    const _highestPeak = Math.max(
                        ..._peakSeries["data"]
                    ).toFixed(0);
                    const _totalUsage = _leveringSeries["data"]
                        .reduce((a, b) => a + b, 0)
                        .toFixed(0);
                    const _totalTerugLevering = _terugleveringSeries["data"]
                        .reduce((a, b) => a + b, 0)
                        .toFixed(0);

                    this.highestPeak = helper.numberWithCommas(_highestPeak);
                    this.totalUsage = helper.numberWithCommas(_totalUsage);
                    this.totalTerugLevering = helper.numberWithCommas(
                        _totalTerugLevering
                    );

                    // update chart
                    // this.$refs?.chart?.updateSeries(this.series);
                }
            },
            watchLoading(isLoading) {
                this.$emit("loading", isLoading);
            },
            // debounce: 500,
            skip() {
                return !this.ean;
            }
            // pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            menu: null,

            yearMonth: null,

            series: [],
            highestPeak: 0,
            totalUsage: 0,
            totalTerugLevering: 0,

            chartOptions: {
                chart: {
                    id: "yearly-usage-chart",
                    type: "line",
                    stacked: false,
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: false
                    },
                    selection: {
                        enabled: false,
                        type: "xy"
                    },
                    brush: {
                        enabled: false
                    },
                    zoom: {
                        enabled: false
                    },
                    events: {
                        // dataPointSelection: (event, chartContext, config) => {
                        //     console.log(event, chartContext, config);
                        //     this.$emit(
                        //         "week-selected",
                        //         config.dataPointIndex + 1
                        //     );
                        // }
                        dataPointSelection: (event, chartContext, config) => {
                            this.routeDay(event, chartContext, config);
                        }
                    }
                },
                xaxis: {
                    // tickPlacement: 'on',
                    type: "category",
                    categories: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31
                    ]
                    // categories: [
                    //     "Januari",
                    //     "Februari",
                    //     "Maart",
                    //     "April",
                    //     "Mei",
                    //     "Juni",
                    //     "Juli",
                    //     "Augustus",
                    //     "September",
                    //     "Oktober",
                    //     "November",
                    //     "December"
                    // ]
                },
                yaxis: [
                    {
                        seriesName: "Levering",
                        showAlways: true,
                        axisTicks: {
                            show: true
                        },
                        axisBorder: {
                            show: false
                            // color: "#2071B5"
                        },
                        labels: {
                            style: {
                                colors: "#2071B5"
                            },
                            formatter: function(val) {
                                return val.toFixed(0);
                            }
                        },
                        title: {
                            text: "Levering / Teruglevering (kWh)",
                            style: {
                                color: "#2071B5"
                            }
                        }
                    },
                    {
                        show: false,
                        seriesName: "Levering"
                    },
                    {
                        seriesName: "Peak",
                        opposite: true,
                        axisTicks: {
                            show: true
                        },
                        axisBorder: {
                            show: false
                            // color: "#E91E63"
                        },
                        labels: {
                            style: {
                                colors: "#E91E63"
                            },
                            formatter: function(val) {
                                return val.toFixed(0);
                            }
                        },
                        title: {
                            text: "Piek (kWh)",
                            style: {
                                color: "#E91E63"
                            }
                        }
                    }
                    // max: 2000 //default value, will be updated by greenhouse total space
                ],
                fill: {
                    opacity: 1
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    width: [1, 1, 2],
                    dashArray: [0, 0, 0]
                },
                markers: {
                    size: [0, 0, 0],
                    offsetX: 0,
                    hover: {
                        size: undefined,
                        sizeOffset: 0
                    }
                },
                colors: ["#2071B5", "#00E396", "#E91E63"],
                legend: {
                    position: "bottom",
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: 5
                },
                states: {
                    active: {
                        filter: {
                            type: "none" /* none, lighten, darken */
                        }
                    }
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: undefined
                    },
                    y: {
                        show: true,
                        formatter: function(value) {
                            return `${value.toFixed(1)} kWh`;
                        },
                        title: {
                            formatter: seriesName => seriesName
                        }
                    },
                    marker: {
                        show: true
                    }
                }
            }
        };
    },

    computed: {
        ean() {
            return this.$route.params.ean || this.propEan;
        },
        minMonth() {
            return "2020-01";
        },
        maxMonth() {
            return moment().format("YYYY-MM");
        },
        yearMonthText() {
            if (!this.yearMonth) return null;

            const [year, month] = this.yearMonth.split("-");
            return `${month}-${year}`;
        },

        startDate() {
            let _date = null;
            if (this.yearMonth) {
                _date = `${this.yearMonth}-01T00:00:00`;
            } else {
                let _dt = new Date();
                // _date = `${_dt.getFullYear()}-${_dt.getMonth() +
                //     1}-01T00:00:00`;
                _date = moment(_dt).format("YYYY-MM-01T00:00:00");
            }

            return _date;
        },
        endDate() {
            let _date = null;
            if (this.yearMonth) {
                // yearMonth example: 2021-10
                let _dt = new Date(
                    Date.UTC(
                        this.yearMonth.substring(0, 4),
                        parseInt(this.yearMonth.substring(5, 7)),
                        0
                    )
                );
                _date = `${_dt.toISOString().substring(0, 10)}T23:59:59`;
            } else {
                let _dt = new Date();
                _date = `${_dt.toISOString().substring(0, 10)}T23:59:59`;
            }

            return _date;
        }
    },
    watch: {
        yearMonth(val) {
            if (val) {
                let _days = new Date(
                    this.yearMonth.substring(0, 4),
                    parseInt(this.yearMonth.substring(5, 7)),
                    0
                ).getDate();

                // generate x-axis category
                this.chartOptions.xaxis.categories = Array.from(
                    { length: _days },
                    (_, i) => 1 + i
                );

                localStorage.measurementFilterMonth = val;

                // // update chart tooltip
                // this.chartOptions = {
                //     ...this.chartOptions,

                //     tooltip: {
                //         x: {
                //             show: true,
                //             formatter: function(value) {
                //                 var _day = value.toString().padStart(2, "0");
                //                 const [year, month] = val.split("-");
                //                 return `${_day}/${month}/${year}`;
                //             }
                //         },
                //         y: {
                //             show: true,
                //             formatter: function(value) {
                //                 return `${value || 0} kWh`;
                //             },
                //             title: {
                //                 formatter: seriesName => seriesName
                //             }
                //         },
                //         marker: {
                //             show: true
                //         }
                //     }
                // };
            }
        },
        $route(to) {
            if (to.query.year && to.query.month) {
                this.yearMonth = `${
                    to.query.year
                }-${to.query.month.toString().padStart(2, "0")}`;
            } else {
                this.initializeMonth();
            }
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        if (this.$route.query.year && this.$route.query.month) {
            this.yearMonth = `${
                this.$route.query.year
            }-${this.$route.query.month.toString().padStart(2, "0")}`;
            this.$router.replace({
                query: {}
            });
        } else {
            this.initializeMonth();
        }
    },
    methods: {
        initializeMonth() {
            if (localStorage.measurementFilterMonth) {
                this.yearMonth = localStorage.measurementFilterMonth;
            } else {
                // set current month as default filter
                let _dt = new Date();
                // this.yearMonth = `${_dt.getFullYear()}-${_dt.getMonth() + 1}`;
                this.yearMonth = moment(_dt).format("YYYY-MM");
            }
        },
        addMonths(months) {
            this.yearMonth = moment(this.yearMonth, "YYYY-MM-01")
                .add(months, "months")
                .format("YYYY-MM");
        },
        routeDay(event, chartContext, config) {
            let _yearMonth = this.yearMonth;
            let _year = _yearMonth.substring(0, 4);
            let _month = _yearMonth.substring(5, 7);
            let _day = config.dataPointIndex + 1;

            if (
                this.$route.query.year == _year &&
                this.$route.query.month == _month &&
                this.$route.query.day == _day
            ) {
                return;
            }

            this.$router.push({
                query: {
                    year: _year,
                    month: _month,
                    day: _day
                }
            });
        }
    }
};
</script>
